import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { UPDATE_USRNAME, UPDATE_USRNAME_SUCCESS, UPDATE_USRNAME_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* UpdateUsername({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/profile/username/update`,
      method: 'POST',
      data: payload.data,
      // isFormData: true,
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: UPDATE_USRNAME_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: UPDATE_USRNAME_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_USRNAME_ERROR, payload: error });
  }
}

export function* watchUpdateUsername() {
  yield takeEvery(UPDATE_USRNAME, UpdateUsername);
}

function* UpdateUsernameSaga() {
  yield all([fork(watchUpdateUsername)]);
}

export default UpdateUsernameSaga;
